module.exports = __webpack_public_path__ + "static/media/exercise.d469fb41.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/images/exercise.jpeg
// module id = 554
// module chunks = 0